module.exports = __webpack_public_path__ + "img/prone_bridge_button.ea8548a9.jpg";